import Modal from "@ui-components/Modal";
import {PriceDifferencesInfoProps, TintometerKColorPriceModalProps} from "./types";
import {useIntl} from "react-intl";
import {useState} from "react";
import RadioGroup from "@ui-components/RadioGroup";
import {computeTotals} from "../quotation-draft/lib/utilities";
import {Discount} from "../types";
import {
  formatCurrency,
  formatNumber,
  formatPercentage,
} from "../quotation-draft/lib/format";
import Input from "@ui-components/Input";
import Button from "@ui-components/Button";

export const PriceDifferencesInfo = ({
  kerakoll,
  tintometer
}: PriceDifferencesInfoProps) => {
  const intl = useIntl();
  return <div className={"flex flex-col"}>
    <span className={"text-gray-400 text-lg"}>
    {kerakoll > 0 ? '-' : '+'}
      {
        formatNumber(Math.abs(kerakoll), {maximumFractionDigits: 2})
      }% {intl.formatMessage({
      id: 'discount_from_kerakoll_price',
      defaultMessage: 'del prezzo di listino Kerakoll'
    })}
    </span>
    <span className={"text-gray-400 text-lg"}>
      {
        formatNumber(
          tintometer
          , {maximumFractionDigits: 2}, true
        )
      }% {intl.formatMessage({
      id: 'discount_from_tintometer_price',
      defaultMessage: 'del prezzo di listino dei componenti'
      })}
    </span>
  </div>
}

export const TintometerKcolorPriceModal = ({
  onConfirm,
  onExit,
  productInfo,
}: TintometerKColorPriceModalProps) => {
  const intl = useIntl();
  const [priceType, setPriceType] = useState<'percent' | 'fixed'>('percent');
  const [discountPercent, setDiscountPercent] = useState<number>(0);

  const totalKerakoll = computeTotals(
    productInfo.quantity,
    productInfo.product.min_qty,
    productInfo.kerakoll_price!,
    {
      type: 'no_discount',
      value: 0,
    } as Discount,
    productInfo.quantity
  )
  const totalTintometer = computeTotals(
    productInfo.quantity,
    productInfo.product.min_qty,
    productInfo.tintometer_price!,
    {
      type: 'no_discount',
      value: 0,
    } as Discount,
    productInfo.quantity
  )
  const [fixedPrice, setFixedPrice] = useState<number>(parseFloat(totalKerakoll.original.toFixed(2)));


  const effectiveTotal = priceType === 'percent' ?
    computeTotals(
      productInfo.quantity,
      productInfo.product.min_qty,
      productInfo.kerakoll_price! * (1 - discountPercent / 100),
      {
        type: 'no_discount',
        value: 0,
      } as Discount,
      productInfo.quantity
    ): null;

  //utilities
  const tintometerEffectivePricePercentageDifference = priceType === 'percent'?(
    (productInfo.kerakoll_price! * (1 - discountPercent / 100)) - productInfo.tintometer_price!
  ) / productInfo.tintometer_price! * 100 : (
    (fixedPrice / productInfo.quantity) - productInfo.tintometer_price!
  ) / productInfo.tintometer_price! * 100;


  const computedDiscountPercentage = (totalKerakoll.original - fixedPrice) / totalKerakoll.original * 100;

  return <Modal
    title="Tintometer K-Color"
    onExit={onExit}
    >
    <div className={"m-2"}>
      <span className={"font-bold text-2xl"}>
      {
        intl.formatMessage({id: 'set_price', defaultMessage: 'Imposta prezzo'})
      }
    </span>
      <div>
        <RadioGroup
          id="price-type"
          horizontal={true}
          options={[
            {name: intl.formatMessage({id: 'percent_discount', defaultMessage: 'Sconto percentuale'}), value: 'percent'},
            {name: intl.formatMessage({id: 'fixed_price', defaultMessage: 'Prezzo netto'}), value: 'fixed'},
          ]}
          currentValue={priceType}
          onChange={(value:'percent'|'fixed') => setPriceType(value as 'percent' | 'fixed')}
          />
      </div>
      <div className={"flex flex-col gap-y-10"}>
        {
          priceType === 'percent' ?
            /* SCONTO PERCENTUALE */
            <div className={"flex flex-col gap-y-8"}>
              <div className={"flex flex-col"}>
                <div className={"flex flex-row gap-x-5 text-lg"}>
                <span>
                  {intl.formatMessage({id: 'kerakoll_price', defaultMessage: 'Prezzo di listino Kerakoll'})}
                </span>
                  <span>
                  {formatCurrency(totalKerakoll.original)}
                </span>
                </div>
                <div className={"flex flex-row gap-x-5 text-lg"}>
                <span>
                  {intl.formatMessage({id: 'tintometer_price', defaultMessage: 'Prezzo dei componenti di listino'})}
                </span>
                  <span>
                  {formatCurrency(totalTintometer.original)}
                </span>
                </div>
              </div>
              <div className={"grid grid-cols-2"}>
                <span className={"font-semibold text-lg"}>
                  {intl.formatMessage({
                    id: 'starting_price',
                    defaultMessage: 'Prezzo di partenza'
                  })}
                </span>
                <span className={"font-semibold text-lg"}>
                  {intl.formatMessage({
                    id: 'discount'
                  })}
                </span>
                <div className={"mt-2 flex flex-row justify-around text-lg"}>
                <span>
                  {
                    formatCurrency(totalKerakoll.original)
                  }
                </span>
                  <span className={'text-red-500'}>
                  &bull;
                </span>
                </div>
                <div className={"flex flex-row gap-x-2"}>
                  <Input
                    type={'number'}
                    value={discountPercent}
                    onChange={(e: any) => {
                      setDiscountPercent(e.target.value)
                    }}
                  />
                  <div className={"text-lg mt-2"}>
                    <span>
                    %
                  </span>
                  </div>
                </div>
              </div>
              <div className={"flex flex-col"}>
                <span className={"font-semibold text-lg"}>
                  {intl.formatMessage({
                    id: 'final_price',
                    defaultMessage: 'Prezzo effettivo'
                  })}
                </span>
                <span className={"text-lg text-red-500 font-semibold"}>
                  {
                    formatCurrency(effectiveTotal!.original)
                  }
                </span>
                <PriceDifferencesInfo
                  kerakoll={discountPercent}
                  tintometer={tintometerEffectivePricePercentageDifference}
                />

              </div>
            </div> :
            /* PREZZO FISSO */
            <div className={"flex flex-col gap-y-8"}>
              <div className={"flex flex-col"}>
              <span className={"font-semibold text-lg"}>
                {
                  intl.formatMessage({id: 'current price', defaultMessage: 'Prezzo attuale'})
                }
              </span>
                <span className={"text-lg"}>
                {
                  formatCurrency(totalKerakoll.original)
                }
              </span>
              </div>
              <div className={"grid grid-cols-2 gap-x-10"}>
                <span className={"text-lg font-semibold"}>
                  {
                    intl.formatMessage({id: 'new_price', defaultMessage: 'Nuovo prezzo'})
                  }
                </span>
                <span className={"text-lg font-semibold"}>
                  {
                    intl.formatMessage({id: 'discount', defaultMessage: 'Sconto'})
                  }
                </span>
                <div className={"flex flex-row gap-x-2"}>
                  <Input
                    type={'number'}
                    value={fixedPrice}
                    onChange={(e: any) => {
                      setFixedPrice(e.target.value)
                    }}
                  />
                  <span className={"mt-2 text-lg"}>
                  €
                  </span>
                </div>
                <div className={"mt-2"}>
                  <span className={"text-lg"}>
                    {
                      formatNumber(
                        computedDiscountPercentage
                        , {maximumFractionDigits: 2},
                      )
                    }%
                  </span>
                </div>
              </div>
              <PriceDifferencesInfo
                kerakoll={computedDiscountPercentage}
                tintometer={tintometerEffectivePricePercentageDifference}
              />
            </div>
        }
        <div className={"flex flex-row justify-center gap-x-5"}>
          <Button
            onClick={() => {
              onExit();
            }}
            styleType={"redWhite"}
          >
            {intl.formatMessage({id: 'cancel', defaultMessage: 'Annulla'})}
          </Button>
          <Button
            onClick={() => {
              onConfirm(
                priceType === 'percent' ?
                  productInfo.kerakoll_price! * (1 - discountPercent / 100) :
                  fixedPrice / productInfo.quantity
              );
            }}
          >
            {intl.formatMessage({id: 'confirm', defaultMessage: 'Conferma'})}
          </Button>
        </div>
      </div>
    </div>
  </Modal>
}